import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	getRegulationsMetrics: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REGULATIONS_METRICS].GET_REGULATIONS_METRICS,
	},
	getRegulationsMetricPreview: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REGULATIONS_METRICS].GET_REGULATIONS_METRIC_PREVIEW,
	},
	getRegulationsMetricPopup: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REGULATIONS_METRICS].GET_REGULATIONS_METRIC_POPUP,
	},
	createRegulationsMetric: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.REGULATIONS_METRICS].CREATE_REGULATIONS_METRIC,
	},
	getRegulationsMetric: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.REGULATIONS_METRICS].GET_REGULATIONS_METRIC,
	},
	patchRegulationsMetric: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.REGULATIONS_METRICS].PATCH_REGULATIONS_METRIC,
	},
	putRegulationsMetric: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.REGULATIONS_METRICS].PUT_REGULATIONS_METRIC,
	},
	deleteRegulationsMetric: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.REGULATIONS_METRICS].DELETE_REGULATIONS_METRIC,
	},
}